import type { SVGProps } from './types';

const EmptyCollection = (props: SVGProps) => {
  const { size = 48, className, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...other}
    >
      <path d="M6 12.5L42 12.5M10 6.5H38M2 18H46V44H2V18Z" stroke="#A4A7AE" strokeWidth="3" />
    </svg>
  );
};

export { EmptyCollection };
